/**
 * Single definition of the Jitsi host that video appointments run on.
 *
 * One shared server serves every tenant today. Keeping the host in one place
 * means a per-tenant (or self-hosted) video server only has to be resolved
 * here — the iframe embed and the three dictation services that validate
 * `postMessage` origins all read it from this module.
 */
export const JITSI_DOMAIN = 'video2.careand.ca';

/** Origin of the Jitsi iframe — compare `MessageEvent.origin` against this. */
export const JITSI_IFRAME_ORIGIN = `https://${JITSI_DOMAIN}`;
